export const WALKIN = {
  List: '/pos/walk-in',
  ListGroupByEmployee: '/pos/walk-in/group-by-employee',
};
